import { useContext } from 'react';
import { IconContext } from 'react-icons';
import { CgSun } from 'react-icons/cg';
import { FaMoon } from 'react-icons/fa';
import { ThemeContext } from '../../context';
import './toggle.css';

const Toggle = () => {
	const theme = useContext(ThemeContext);

	const handleToggleClick = () => {
		theme.dispatch({ type: 'TOGGLE' });
	};

	return (
		<IconContext.Provider value={{ className: 'toggle-icon' }}>
			<div className='toggle-container'>
				<CgSun color='black' />
				<FaMoon style={{ color: theme.state.darkMode && 'black' }} />
				<div
					className='toggle-button'
					onClick={handleToggleClick}
					style={{ left: theme.state.darkMode ? 0 : 25 }}
				></div>
			</div>
		</IconContext.Provider>
	);
};

export default Toggle;
